import React, { useState } from 'react';
import ReviewListPresenter from './WrittenReviewPresenter';

import { CapaQuotationPartnerRfqReviewResult } from '@generated/graphql';

interface Props {
  reviewInfo?: CapaQuotationPartnerRfqReviewResult;
}

const WrittenReviewContainer = ({ reviewInfo }: Props) => {
  const [visibleCount, setVisibleCount] = useState(4);

  const reviews = reviewInfo?.reviews ?? [];

  const reviewsTotalCount = reviews.length;

  const handleVisibleCount = () => {
    return setVisibleCount((prev) => {
      if (prev + 4 >= reviewsTotalCount) {
        return reviewsTotalCount;
      }

      return prev + 4;
    });
  };

  return (
    <ReviewListPresenter
      reviewInfo={reviewInfo}
      visibleCount={visibleCount}
      handleVisibleCount={handleVisibleCount}
    />
  );
};

export default WrittenReviewContainer;
